(function () {
  'use strict';

  var KEY = 'lc_recent';
  var MAX = 12;

  /* ── 1. Track every product page visit ── */
  var productMatch = window.location.pathname.match(/\/products\/([^/?#]+)/);
  if (productMatch) {
    var handle = productMatch[1];
    var list = JSON.parse(localStorage.getItem(KEY) || '[]');
    list = list.filter(function (h) { return h !== handle; });
    list.unshift(handle);
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  }

  /* ── 2. Render on cart page ── */
  var section = document.getElementById('lcu-recent-section');
  var track   = document.getElementById('lcu-recent-track');
  if (!section || !track) return;

  var handles = JSON.parse(localStorage.getItem(KEY) || '[]');
  if (!handles.length) return;

  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cartData) {
      var cartPids = cartData.items.map(function (i) { return i.product_id; });

      return Promise.all(
        handles.map(function (h) {
          return fetch('/products/' + h + '.js')
            .then(function (r) { return r.ok ? r.json() : null; })
            .catch(function () { return null; });
        })
      ).then(function (products) {
        return { products: products, cartPids: cartPids };
      });
    })
    .then(function (data) {
      var cards = '';
      var shown = 0;

      data.products.forEach(function (p) {
        if (!p || !p.available || shown >= 8) return;
        if (data.cartPids.indexOf(p.id) !== -1) return;

        var v = p.variants[0];
        var imgSrc = p.featured_image
          ? p.featured_image.replace(/(\.[^.?]+)(\?.*)?$/, '_300x300$1')
          : '';
        var price        = money(v.price);
        var comparePrice = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
        var savePct      = v.compare_at_price > v.price
          ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price)
          : 0;
        var title = p.title.length > 60 ? p.title.substring(0, 57) + '…' : p.title;

        cards +=
          '<div class="lcu-card" data-product-id="' + p.id + '">' +
            '<a href="/products/' + p.handle + '" class="lcu-card__img-link" tabindex="-1" aria-hidden="true">' +
              (imgSrc
                ? '<img class="lcu-card__img" src="' + imgSrc + '" alt="" width="150" height="150" loading="lazy">'
                : '<div class="lcu-card__img lcu-card__img--placeholder"></div>') +
            '</a>' +
            '<div class="lcu-card__body">' +
              '<a href="/products/' + p.handle + '" class="lcu-card__title">' + escHtml(title) + '</a>' +
              '<div class="lcu-card__meta">' +
                (comparePrice ? '<span class="lcu-card__compare">' + comparePrice + '</span>' : '') +
                '<span class="lcu-card__price">' + price + '</span>' +
                (savePct ? '<span class="lcu-card__badge">Save ' + savePct + '%</span>' : '') +
              '</div>' +
              '<button class="lcu-card__btn" data-variant-id="' + v.id + '" aria-label="Add ' + escAttr(p.title) + ' to cart">' +
                '<span class="lcu-btn-state lcu-btn-state--idle">' +
                  '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
                  ' Add to Cart' +
                '</span>' +
                '<span class="lcu-btn-state lcu-btn-state--loading" hidden>Adding…</span>' +
                '<span class="lcu-btn-state lcu-btn-state--done" hidden>' +
                  '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>' +
                  ' Added!' +
                '</span>' +
              '</button>' +
            '</div>' +
          '</div>';

        shown++;
      });

      if (!cards) return;

      track.innerHTML = cards;
      section.style.display = '';

      track.addEventListener('click', function (e) {
        var btn = e.target.closest('.lcu-card__btn');
        if (!btn || btn.disabled) return;

        var variantId = parseInt(btn.dataset.variantId, 10);
        var idle    = btn.querySelector('.lcu-btn-state--idle');
        var loading = btn.querySelector('.lcu-btn-state--loading');
        var done    = btn.querySelector('.lcu-btn-state--done');

        btn.disabled   = true;
        idle.hidden    = true;
        loading.hidden = false;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function () {
          loading.hidden = true;
          done.hidden    = false;
          btn.classList.add('lcu-card__btn--done');
          btn.closest('.lcu-card').classList.add('lcu-card--added');
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(function () { window.location.reload(); }, 1000);
        })
        .catch(function () {
          btn.disabled   = false;
          loading.hidden = true;
          idle.hidden    = false;
        });
      });
    });

  function money(cents) {
    var fmt = (window.Shopify && Shopify.money_format) || '£{{amount}}';
    return fmt
      .replace('{{amount}}', (cents / 100).toFixed(2))
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount_with_comma_separator}}', (cents / 100).toFixed(2).replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100));
  }

  function escHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function escAttr(s) {
    return String(s).replace(/"/g, '&quot;');
  }
})();
